import styles from './A_ProgressBar.module.css';

interface A_ProgressBarProps {
  progress: number;
}

export default function A_ProgressBar({ progress }: A_ProgressBarProps) {
  const clampedProgress = Math.max(0, Math.min(100, progress));

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.progress_bar_fill}
        style={{
          width: `${clampedProgress}%`,
        }}
      />
    </div>
  );
}
